export const index9to7: Record<number, number> = {
    0: 0,
    1: 1,
    2: 2,
    3: -1,
    4: 3,
    5: -1,
    6: 4,
    7: 5,
    8: 6,
}
export const indices9to7 = (indices: number[]) => indices.map(i => index9to7[i]).filter(v => v !== -1)